export default {
    'en2.classba.cn': 9310001,
    'en2.171xue.com': 9310001,
    'mmath.classba.cn': 9310001,
    'mmath.171xue.com': 9310001,
    'cn2.classba.cn': 9310001,
    'cn2.171xue.com': 9310001,
    'phy.classba.cn': 9310001,
    'phy.171xue.com': 9310001,
    'module-chem.classba.cn': 9310001,
    'module-chem.171xue.com': 9310001,
    'mphys.classba.cn': 9310001,
    'mphys.171xue.com': 9310001,
    'mchem.classba.cn': 9310001,
    'mchem.171xue.com': 9310001,
    'hmath.classba.cn': 9310001,
    'hmath.171xue.com': 9310001,
    'hphys.classba.cn': 9310001,
    'hphys.171xue.com': 9310001,
    'en-grammar.classba.cn': 9310001,
    'en-grammar.171xue.com': 9310001,
    'demo.classba.cn': 9310001,
    'demo.171xue.com': 9310001,
    'trial.classba.cn': 9310001,
    'trial.171xue.com': 9310001,
    'study.classba.cn': 9310001,
    'study.171xue.com': 9310001,
    'pioneer.classba.cn': 9310001,
    'pioneer.171xue.com': 9310001,
    'en-reading.classba.cn': 9310001,
    'en-reading.171xue.com': 9310001,
    'en-new.classba.cn': 9310001,
    'en-new.171xue.com': 9310001,
    'module-cn.classba.cn': 9310001,
    'module-cn.171xue.com': 9310001,
    'cn-new.classba.cn': 9310001,
    'cn-new.171xue.com': 9310001,
    'math2.classba.cn': 9310001,
    'math2.171xue.com': 9310001,
    'module.classba.cn': 9310001,
    'module.171xue.com': 9310001
};